export class AutoplayMenuViewEvents {
	public static readonly UPDATE_AUTOPLAY_SPINS: string = 'AutoplayMenuViewEvents::UPDATE_AUTOPLAY_SPINS';
	public static readonly ACCEPTED: string = 'AutoplayMenuViewEvents::ACCEPTED';
	public static readonly CANCELLED: string = 'AutoplayMenuViewEvents::CANCELLED';
	public static readonly BUTTON_PRESSED: string = 'AutoplayMenuViewEvents::BUTTON_PRESSED';
	public static readonly AUTO_PLAY_MENU_OPENED: string = 'AutoplayMenuViewEvents::AUTO_PLAY_MENU_OPENED';
	public static readonly AUTO_PLAY_MENU_CLOSED: string = 'AutoplayMenuViewEvents::AUTO_PLAY_MENU_CLOSED';
	public static readonly UPDATE_AUTOPLAY_VALUES: string = 'AutoplayMenuViewEvents::UPDATE_AUTOPLAY_VALUES';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/popupmenus/autoplaymenu/AutoplayMenuViewEvents.ts